export class ReportVehicleDetails {
  constructor(
    public readonly brand: string[] | null = null,
    public readonly model: string[] | null = null,
    public readonly vin: string[] | null = null,
    public readonly registrationPlate: string[] | null = null,
    public readonly fabricNumber: string[] | null = null,
    public readonly itemCategory: string[] | null = null,
    public readonly ownerId: number[] | null = null,
    public readonly storageId: number[] | null = null,
    public readonly returningPerson: string[] | null = null,
    public readonly arrivalDateFrom: string | null = null,
    public readonly arrivalDateTo: string | null = null,
    public readonly releaseDateFrom: string | null = null,
    public readonly releaseDateTo: string | null = null,
    public readonly receiver: string[] | null = null,
    public readonly keyNumber: number[] | null = null,
    public readonly documentNumber: number[] | null = null,
    public readonly archiveNumber: number[] | null = null,
  ) {
  }
}
